import * as React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core'

type MrdoorDialogProps = {
    title?: string,
    content: string,
    confirm?: string,
    cancel?: string,
    open: boolean,
    href?: string,
    onClose: (type: number) => void
}

const MrdoorDialog = ({ open, cancel, confirm, content, title, onClose, href }: MrdoorDialogProps) => {


    const handleClose = (type: number) => () => {
        onClose(type)
    }

    return <Dialog open={open} onClose={handleClose(2)}>
        {title && <DialogTitle>{title}</DialogTitle>}
        <DialogContent>
            <DialogContentText>
                {content}
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            {cancel && <Button onClick={handleClose(0)}>{cancel}</Button>}
            <Button href={href} onClick={handleClose(1)} color="secondary" >{confirm ? confirm : 'confirm'}</Button>
        </DialogActions>
    </Dialog>
}

export default MrdoorDialog